import { render, staticRenderFns } from "./PAlert.vue?vue&type=template&id=2c589d80&scoped=true"
import script from "./PAlert.vue?vue&type=script&lang=js"
export * from "./PAlert.vue?vue&type=script&lang=js"
import style0 from "./PAlert.vue?vue&type=style&index=0&id=2c589d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c589d80",
  null
  
)

export default component.exports